import { ArrowBack } from '@mui/icons-material';
import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import PromoBgr from '../../../assets/Promo_bgr.jpeg';
import Button from '../../../Ui/FormButton';
import { MainButton } from '../../Button';
import { whatsAppLink } from '../../../../utils';

const Wrapper = styled.div`
  background-image: -webkit-linear-gradient(top, rgb(52, 90, 128), rgba(163, 163, 163, 0.7));
  padding: 24px 0 56px;
`;

const Title = styled(Typography).attrs({ variant: 'h1' })`
  @media screen and (max-width: 600px) {
    font-size: 24px !important;
  }
`;

const List = styled.ul`
  padding: 0;
  margin-top: 16px;
`;

const ListItem = styled.li`
  margin: 0 24px;
`;

const Promo = ({ title, about }) => {
  const history = useHistory();

  const handleClick = () => {
    if (history.length === 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  return (
    <Box sx={{ background: `url(${PromoBgr}) no-repeat center/cover;`, color: '#fff' }}>
      <Wrapper>
        <Container>
          <ArrowBack onClick={handleClick} sx={{ mb: 3, cursor: 'pointer' }} />
          <Title
            sx={{
              marginBottom: '56px',
              color: '#fff',
            }}
          >
            {title}
          </Title>
          <List>
            {about.map(listItem => (
              <ListItem key={listItem}>{listItem}</ListItem>
            ))}
          </List>
          <MainButton margin="72" text="Связажитесь с нами" href={whatsAppLink} />
        </Container>
      </Wrapper>
    </Box>
  );
};

export default Promo;
